export default "__VITE_ASSET__1d0d3402__"